import React from "react";

export const Logo = ({ className = "h-8 w-8", mono = false }) => {
  const stroke = mono ? "currentColor" : "#C85A32";
  const stroke2 = mono ? "currentColor" : "#2D6A4F";
  const fill = mono ? "currentColor" : "#C85A32";
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="MĀTI MORBI mark"
    >
      <path
        d="M20 4L32 12V28L20 36L8 28V12L20 4Z"
        stroke={stroke}
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M20 12V28"
        stroke={stroke2}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M14 18L20 12L26 18"
        stroke={stroke2}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="20" cy="28" r="2" fill={fill} />
    </svg>
  );
};

export const Wordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <Logo className="h-7 w-7" />
    <div className="leading-none">
      <div className="font-display text-[15px] font-extrabold tracking-[0.14em]">
        MĀTI
      </div>
      <div className="font-mono-ui text-[9px] tracking-[0.32em] text-[color:var(--mati-muted)] mt-0.5">
        MORBI · EST 2025
      </div>
    </div>
  </div>
);

export default Logo;
